import { useAuthStore } from '@/stores/authStore'
import { formatRole } from '@/utils/formatRole'

export default function DashboardPage() {
  const { user } = useAuthStore()

  return (
    <div className="container">
      <h1 style={{ marginBottom: '2rem' }}>Dashboard</h1>
      
      <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))' }}>
        <div className="card">
          <h3>Hey there, {user?.name?.split(' ')[0] || 'explorer'}! 👋</h3>
          <p style={{ marginTop: '1rem', color: 'var(--color-gray-600)' }}>
            Ready to discover amazing experiences? Let's get you exploring.
          </p>
          <div style={{ marginTop: '1.5rem', paddingTop: '1.5rem', borderTop: '1px solid var(--color-gray-200)' }}>
            <p style={{ marginBottom: '0.5rem' }}>
              <strong>Email:</strong> {user?.email}
            </p>
            <p>
              <strong>Role:</strong> {formatRole(user?.role)}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

